import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { VyLayout } from '../../../components/new-design/layout/VyLayout';
import { withGlobalSearchParams } from '../../../components/utility/GlobalSearchParamsBoundary';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { MonthlyClosureReportContent } from './monthly-closure-report-page-components/MonthlyClosureReportContent';

const MonthlyClosureReportPage: React.FC = () => {
  const { reportId } = useParams();

  return (
    <>
      <Helmet>
        <title>Report</title>
      </Helmet>
      <VyLayout>
        <MonthlyClosureReportContent reportId={reportId} />
      </VyLayout>
    </>
  );
};

const MonthlyClosureReportPageWithSuspenseBoundary = withSuspenseBoundary(
  withGlobalSearchParams(MonthlyClosureReportPage),
);
export { MonthlyClosureReportPageWithSuspenseBoundary as MonthlyClosureReportPage };
